import type { FC } from 'react';
import { useEffect, useState } from 'react';

import TextInputField from '@/components/Form/Fields/TextInputField';
import { useDebounce } from '@/hooks/useDebounce';
import { useExternalCandidate } from '@/hooks/useExternalCandidate';
import { usePatchExternalCandidate } from '@/hooks/usePatchExternalCandidate';

type Props = {
  profileId: number;
};

const GithubUrlField: FC<Props> = ({ profileId }) => {
  const [githubUrl, setGithubUrl] = useState<string | null>(null);

  const { data } = useExternalCandidate(profileId, {
    staleTime: 1000 * 60 * 10,
  });

  const { mutate } = usePatchExternalCandidate();

  const debouncedGithubUrl = useDebounce(githubUrl);

  useEffect(() => {
    if (githubUrl !== null || !data?.githubUrl) return;
    setGithubUrl(data.githubUrl);
  }, [githubUrl, data?.githubUrl]);

  useEffect(() => {
    if (debouncedGithubUrl === null) return;
    if (debouncedGithubUrl === data?.githubUrl) return;

    mutate({ id: profileId, data: { githubUrl: debouncedGithubUrl } });
  }, [debouncedGithubUrl, data?.githubUrl]);

  return (
    <TextInputField
      value={githubUrl ?? ''}
      onChange={(e) => setGithubUrl(e.currentTarget.value)}
      placeholder="Enter GitHub link here..."
      variant="light"
    />
  );
};

export default GithubUrlField;
